const SvgSelector = ({ svg }) => {
  switch (svg) {
    case 'arrow':
      return (
        <svg
          width='70'
          height='70'
          viewBox='0 0 70 70'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          {/* <circle cx='35' cy='35' r='34' fill='white' stroke='#886B58' stroke-width='2' /> */}
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M41.9052 23.4773L52.5118 33.8477C53.1627 34.4841 53.1627 35.5159 52.5118 36.1523L41.9052 46.5227C41.2544 47.1591 40.1991 47.1591 39.5482 46.5227C38.8973 45.8863 38.8973 44.8546 39.5482 44.2182L47.3096 36.6296L18 36.6296V33.3704L47.3096 33.3704L39.5482 25.7818C38.8973 25.1454 38.8973 24.1137 39.5482 23.4773C40.1991 22.8409 41.2544 22.8409 41.9052 23.4773Z'
            fill='#2D2D2D'
          />
        </svg>
      );

    case 'dropdownArrow':
      return (
        <svg
          width='40'
          height='40'
          viewBox='0 0 40 40'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle
            cx='20'
            cy='20'
            r='19'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='2'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.5858 15.5858C11.3668 14.8047 12.6332 14.8047 13.4142 15.5858L20 22.1716L26.5858 15.5858C27.3668 14.8047 28.6332 14.8047 29.4142 15.5858C30.1953 16.3668 30.1953 17.6332 29.4142 18.4142L20 27.8284L10.5858 18.4142C9.80474 17.6332 9.80474 16.3668 10.5858 15.5858Z'
            fill='currentColor'
          />
        </svg>
      );

    case 'play':
      return (
        <svg
          width='80'
          height='80'
          viewBox='0 0 80 80'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='40' cy='40' r='40' fill='#D97752' />
          <path
            d='M57 37.768C58.3333 38.5378 58.3333 40.4622 57 41.232L32.25 55.5215C30.9167 56.2913 29.25 55.329 29.25 53.7894L29.25 25.2106C29.25 23.671 30.9167 22.7087 32.25 23.4785L57 37.768Z'
            fill='white'
          />
        </svg>
      );
    case 'pause':
      return (
        <svg
          width='40'
          height='40'
          viewBox='0 0 40 40'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='20' cy='20' r='19' stroke='#886B58' stroke-width='2' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.5858 15.5858C11.3668 14.8047 12.6332 14.8047 13.4142 15.5858L20 22.1716L26.5858 15.5858C27.3668 14.8047 28.6332 14.8047 29.4142 15.5858C30.1953 16.3668 30.1953 17.6332 29.4142 18.4142L20 27.8284L10.5858 18.4142C9.80474 17.6332 9.80474 16.3668 10.5858 15.5858Z'
            fill='#886B58'
          />
        </svg>
      );
    default:
      return <></>;
  }
};

export default SvgSelector;
